import { Icon } from '@pwc/pwc-deals-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  isLiveLinkingEnabled,
  getProjectSource,
} from '../../../../features/project/projectSlice';
import { isDtp } from '../../ProjectRoleUsersField/UserSettingsRightsMatrix.ts';
import styles from './LiveLinkingIndicator.module.scss';

const LiveLinkingIndicator = () => {
  const isEnabled = useSelector(isLiveLinkingEnabled);
  const projectSource = useSelector(getProjectSource);
  const { t } = useTranslation();

  if (!isEnabled) {
    return null;
  }

  return (
    <div className={styles['confirmation-indicator']}>
      <Icon name="information" className="fill icon-grey" width={18} />
      <p data-testid="popover-confirmation-message">
        {t(
          isDtp(projectSource)
            ? 'powerBiAndTableauContentWillBeLinkedLive'
            : 'powerBiContentWillBeLinkedLive'
        )}
      </p>
    </div>
  );
};

export default LiveLinkingIndicator;
